/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const SET_SELECTED_USER_DETAILS = 'SET_SELECTED_USER_DETAILS';
export const SET_FILTERED_USERS = 'SET_FILTERED_USERS';
export const SET_NO_ITEM = 'SET_NO_ITEM';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const SET_SEARCH_KEY = 'SET_SEARCH_KEY';
export const RESET_USERS = 'RESET_USERS';
export const RESET_USER_FORMDATA = 'RESET_USER_FORMDATA';
export const SET_USER_FORMDATA = 'SET_USER_FORMDATA';
export const RESET_SELECTED_USER_DETAILS = 'RESET_SELECTED_USER_DETAILS';
export const SET_IDPS = "SET_IDPS";
export const SET_IDP_ROLES = "SET_IDP_ROLES";
export const SET_ROLES_TO_ASSIGN = 'SET_ROLES_TO_ASSIGN';
